import { ConfigService } from "./../../services/config.service";
import { DetailedQuotaComponent } from "./../detailed-quota/detailed-quota.component";
import { SlickMarketWatchComponent } from "./../../components/slick-market-watch/slick-market-watch.component";
import { ApiService } from "./../../services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { MarketNewsComponent } from "./../../components/market-news/market-news.component";
import { OrderBookComponent } from "./../../components/order-book/order-book.component";
import { MarketTradesComponent } from "./../../components/market-trades/market-trades.component";
import { MarketDepthComponent } from "./../../components/market-depth/market-depth.component";
import { GridsterService } from "./../../services/gridster.service";
import { MarketDepthBidsComponent } from "./../../components/market-depth-bids/market-depth-bids.component";
import { MarketDepthAsksComponent } from "./../../components/market-depth-asks/market-depth-asks.component";
import { TradesComponent } from "./../../components/trades/trades.component";
import { NewsComponent } from "./../../components/news/news.component";
import { HistoricalComponent } from "./../../components/historical/historical.component";
import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { CompanyList } from "src/app/models/company-list";
import {
  CompactType,
  DirTypes,
  DisplayGrid,
  GridsterConfig,
  GridsterItem,
  GridType,
} from "angular-gridster2";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { AccountService } from "src/app/services/account.service";
import { UserIdleService } from "angular-user-idle";
import { SignalRService } from "src/app/services/signalr.service";
import { TradingViewChartComponent } from "src/app/components/trading-view-chart/trading-view-chart.component";
import { FavService } from "src/app/services/fav.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, AfterViewInit {
  isCompaniesLoading: boolean;
  selectedCompanySymbol: any;
  options: GridsterConfig;
  dashboard: Array<GridsterItem>;
  @ViewChildren("MWT") components: QueryList<any>;

  companies: CompanyList[];

  records = [];
  toggleBool = false;
  selectedEgx: CompanyList;

  companiesUpdates: any = [];
  selectedCompanyReuters: any;

  selectedCompanyName: any;
  isMarket: boolean;
  dashboardIndex = 0;
  dashboardList: Array<GridsterItem>[];

  credentialsSearchFilter(event: any) {
    const val = event.target.value.toLowerCase();

    if (val != "") {
      this.toggleBool = true;
    } else {
      this.toggleBool = false;
    }

    this.records = this.companies.filter(function (d) {
      return d.ENG_NAME?.toLowerCase().includes(val);
    });
  }

  static itemChange(item, itemComponent) {
  }

  static itemResize(item, itemComponent) {
  }

  navigateProfile(item) {
    this.nav
      .navigate(["/company-profile", item.SYMBOL_CODE, item.Reuters])
      .then(() => (this.toggleBool = false));
  }

  slideConfig = {
    speed: 15000,
    autoplay: true,
    autoplaySpeed: 100,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    infinite: true,
  };

  ngOnInit(): void {
    // right when the component initializes, start reset state and start watching
    this.options = {
      gridType: GridType.ScrollVertical,
      compactType: CompactType.CompactUpAndLeft,
      itemChangeCallback: () => {
        this.gridService.updateGridWithIndex(
          this.dashboardIndex,
          this.dashboard
        );
        this.WindowResize();
      },
      draggable: {
        enabled: true,
      },
      resizable: {
        enabled: true,
        handles: {
          s: false,
          e: false,
          n: false,
          w: false,
          se: true,
          ne: false,
          sw: true,
          nw: false,
        },
      },
      outerMargin: true,
      outerMarginLeft: 20,
      setGridSize: true,
      swap: true,
      pushItems: true,
      displayGrid: DisplayGrid.None,
      disableWindowResize: true,
      scrollToNewItems: true,
      minCols: 20,
      minRows: 10,
      maxCols: 30,
      minItemCols: 6,
      minItemRows: 5,
      dirType: this.translate.currentLang == "ar" ? DirTypes.RTL : DirTypes.LTR,
    };

    setTimeout(() => {
      this.dashboardList = this.gridService.getGrid();
      this.dashboard = this.dashboardList[this.dashboardIndex];
    }, 100);

    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((count) => {
      // Swal.getState().
      if (!Swal.isVisible()) {
        let timerInterval;
        Swal.fire({
          title: this.translate.instant("auto-close"),
          html: "<strong></strong><br/>",
          timer: this.popupAlertTime * 1000,
          timerProgressBar: true,
          didOpen: () => {
            const content = Swal.getHtmlContainer();
            Swal.showLoading();
            timerInterval = setInterval(() => {
              content.getElementsByTagName("strong").item(0).innerHTML = (
                Swal.getTimerLeft() / 1000
              ).toFixed(0);
            }, 100);
          },
          willClose: () => {
            this.userIdle.resetTimer();
          },
        });
      }
    });

    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      if (sessionStorage.getItem("userName") != null) {
        let userName = sessionStorage.getItem("userName");
        this.apiService.logOut(userName).subscribe(
          (x) => {
            this.accService.logout();
          },
          (err) => {
          }
        );
        this.userIdle.stopTimer();
        this.userIdle.stopWatching();
      }
    });
  }

  addNewDashboard() {
    let index = this.gridService.addNewDashboard();
    this.dashboardList = this.gridService.getGrid();
    this.dashboardIndex = index - 1;
    this.dashboard = this.dashboardList[this.dashboardIndex];
    this.WindowResize();
  }
  switchDashboard(index) {
    this.dashboardIndex = index;
    this.dashboard = this.dashboardList[index];
  }
  removeDashboard(index) {
    // let index = this.gridService.addNewDashboard();
    this.gridService.removeDashboard(index);
    this.dashboardIndex = 0;
    this.dashboardList = this.gridService.getGrid();
    this.dashboard = this.dashboardList[this.dashboardIndex];
    this.WindowResize();
  }

  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }

  get(comp) {
    switch (comp) {
      case "market-watch":
        return SlickMarketWatchComponent;
      case "news":
        return NewsComponent;
      case "trades":
        return TradesComponent;
      case "depth-asks":
        return MarketDepthAsksComponent;
      case "depth-bids":
        return MarketDepthBidsComponent;
      case "market-depth":
        return MarketDepthComponent;
      case "market-trades":
        return MarketTradesComponent;
      case "historical":
        return HistoricalComponent;
      case "bids":
        return MarketDepthBidsComponent;
      case "asks":
        return MarketDepthAsksComponent;
      case "order-book":
        return OrderBookComponent;
      case "market-news":
        return MarketNewsComponent;
      // case "detailed-quota":
      //   return DetailedQuotaComponent;
      case "chart":
        return TradingViewChartComponent;
    }
  }

  ngAfterViewInit() {
    this.components.changes.subscribe((queryList) => {
      this.components.forEach((element) => {
        element.componentRef.instance.fireFunction = (
          symbol,
          reuter,
          nameEn,
          nameAr
        ) => {
          this.selectedCompanySymbol = symbol;
          this.selectedCompanyReuters = reuter;
          if (this.translate.currentLang == "ar") {
            this.selectedCompanyName = nameAr;
          }
          if (this.translate.currentLang == "en") {
            this.selectedCompanyName = nameEn;
          }
        };

        element.componentRef.instance.addWidget = (
          name,
          companyData,
          isLinked
        ) => {
          this.dashboard.push({
            cols: name == "chart" ? 15 : 8,
            rows: 6,
            y: 0,
            x: 0,
            dragEnabled: true,
            resizeEnabled: true,
            name: name,
            symbolCode: companyData.symbol,
            reuters: companyData.reuters,
            companyName: companyData.name,
            isLinked: isLinked,
          });
        };
      });
    });
  }

  changedOptions(): void {
    if (this.options.api && this.options.api.optionsChanged) {
      this.options.api.optionsChanged();
    }
  }

  removeItem($event: MouseEvent | TouchEvent, item) {
    setTimeout(() => {
      $event.preventDefault();
      $event.stopPropagation();
      this.dashboard.splice(this.dashboard.indexOf(item), 1);
      this.gridService.updateGridWithIndex(this.dashboardIndex, this.dashboard);
      this.WindowResize();
    }, 0);
  }

  popupAlertTime = 10;

  constructor(
    public gridService: GridsterService,
    public translate: TranslateService,
    private _service: ApiService,
    private nav: Router,
    public accService: AccountService,
    private apiService: ApiService,
    private configService: ConfigService,
    private userIdle: UserIdleService,
    public signalR: SignalRService,
    private favService: FavService
  ) {
    // signalR.connectBidsAsksUpdates();
    this.signalR.connectMarketWatch();
    this.signalR.connectTradesUpdates();

    if (!this.userIdle)
      this.userIdle.setConfigValues({
        idle: this.configService.getIdleTime,
        timeout: 10,
      });

    this.isCompaniesLoading = true;
    this._service.fetchTodayMarketWatch().subscribe((res) => {
      this.isCompaniesLoading = false;
      this.companies = res as any[];
      this.WindowResize();
    });

    //this.favService.fetchFavs();

    this.gridService.onNewGenericAdded().subscribe((res) => {
      this.dashboard.push(res);
    });

    this.accService.isFullMarketUser.subscribe((isMarket) => {
      this.isMarket = isMarket;
    });
  }

  ngOnDestroy(): void {
    this.signalR.disconnectMwSignalr();
    this.signalR.disconnectTradesSignalr();
  }
}
